import PropTypes from "prop-types";
import React from "react";
import { NavLink } from "react-router-dom";
import { NipNavbar } from "../../components/Nip/Navbar";
import NipSidebar from "../../components/Nip/Sidebar";
import SideMenu from "../../components/Nip/SideMenu";

const NipWrapper = ({ children }) => {
  return (
    <div className="container">
      <NipNavbar />
      <NipSidebar />

      <div className="container-body-staff">
        <div className="general-wrapper">
          <div className="general-wrapper-left">{children}</div>
          <div className="general-wrapper-right">
            {<div className="general-wrapper-right-links">
              <NavLink to="/nip/home" activeClassName="nip-bar">
                <div className="link-1">Test Environment</div>
              </NavLink>
              <NavLink to="/nip/integration" activeClassName="nip-bar">
                <div className="link-2">Integration</div>
              </NavLink>
            </div>}
            <SideMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

NipWrapper.propTypes = {
  children: PropTypes.any,
};

export default NipWrapper;
